<template>
  <div class="SMenu noprint">
    <nav>
      <ul>
        <li>
          <router-link :to="'/home'"
            ><img src="/picto/maison.svg" alt="" /> accueil</router-link
          >
        </li>
        <li>
          <router-link :to="'/projects'"
            ><img src="/picto/dossier.svg" alt="" /> projets</router-link
          >
        </li>
        <li>
          <router-link :to="'/partners'"
            ><img src="/picto/usine.svg" alt="" /> entreprises</router-link
          >
        </li>
        <li>
          <router-link :to="'/contacts'"
            ><img src="/picto/contacts.svg" alt="" /> contacts</router-link
          >
        </li>
        <li>
          <router-link :to="'/cherchables'"
            ><img src="/picto/loupe.svg" alt="" /> cherchables</router-link
          >
        </li>
        <li>
          <router-link :to="'/agence'"
            ><img src="/picto/crayon_regle.svg" alt="" /> agence</router-link
          >
        </li>
        <li>
          <a @click.prevent="show_web = !show_web"
            ><img src="/picto/planete.svg" alt="" /> scalene.fr</a
          >
          <ul v-show="show_web">
            <li>
              <router-link :to="'/website/tech'"
                ><img src="/picto/sliders_reglages.svg" alt="" /> réglages
                techniques</router-link
              >
            </li>
            <li>
              <router-link :to="'/website/home_v2'"
                ><img
                  style="height: 0.7em; width: auto; opacity: 0.95"
                  src="/picto/maison.png"
                  alt=""
                />
                accueil V2</router-link
              >
            </li>
            <li>
              <router-link :to="'/website/projects_selection'"
                ><img
                  style="height: 0.7em; width: auto; opacity: 0.95"
                  src="/picto/photo.png"
                  alt=""
                />
                sélection de projets</router-link
              >
            </li>
            <li>
              <router-link :to="'/website/menu'"
                ><img src="/picto/crayon.svg" alt="" /> menu et
                titres</router-link
              >
            </li>
            <li>
              <router-link :to="'/website/axes'"
                ><img src="/picto/pensee.svg" alt="" /> axes de
                travail</router-link
              >
            </li>
            <li>
              <router-link :to="'/website/projects'"
                ><img src="/picto/grue.svg" alt="" /> projets</router-link
              >
            </li>
            <li>
              <router-link :to="'/website/informations'"
                ><img src="/picto/informations.svg" alt="" /> à
                propos</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link :to="'/outils'"
            ><img src="/picto/mallette.svg" alt="" /> outils divers</router-link
          >
        </li>
        <li>
          <router-link :to="'/export/agence_about'"
            ><img src="/picto/informations.svg" alt="" /> fiche
            informations</router-link
          >
        </li>
      </ul>
      <ul class="server">
        <li class="server-info is-size-7">État de santé serveur</li>
        <li class="server-info is-size-7" v-if="meta.uptime">
          Actif : {{ meta.uptime.days }} jours, {{ meta.uptime.hours }}h
          {{ meta.uptime.minutes }}m
        </li>
        <li class="server-info is-size-7" v-if="meta.diskUsage">
          Disque : {{ toRemainingPercent(meta.diskUsage) }}% libre
        </li>
        <li class="server-info is-size-7" v-if="meta.memUsage">
          Mémoire : {{ toRemainingPercent(meta.memUsage) }}% libre
        </li>
      </ul>
      <ul class="bottom">
        <li class="logout is-size-7">
          <a href="#" @click.prevent="logout">déconnexion</a> <br /><br />
          <a
            href="https://github.com/documents-org/bdd.scalene.fr/issues"
            target="_blank"
            >signaler un problème sur github</a
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { types as t } from "../store/actions/auth";
import { types as m } from "../store/actions/misc";

export default {
  name: "SMenu",
  data() {
    return {
      show_web: false,
      meta: {}
    };
  },
  methods: {
    logout() {
      this.$store.dispatch(t.LOGOUT);
      this.$router.push("/auth/login");
    },
    toRemainingPercent(floatVal) {
      return (100 - 100 * floatVal).toFixed(2);
    }
  },
  async mounted() {
    if (!window.HEADLESS) {
      this.meta = await this.$store.dispatch(m.GET_VARIOUS_META);
    }
  }
};
</script>

<style lang="scss">
$blue: #00008c;

.SMenu {
  height: 100%;
  color: $blue;
  font-family: Synthese;
  nav {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .server {
    margin-top: auto;
  }
  .bottom {
    margin-top: 3em;
    a {
      color: firebrick;
    }
  }
  .server-info {
    margin-top: 0.5em;
    progress {
      display: inline-block;
      width: auto;
    }
  }
  a {
    color: $blue !important;
    text-decoration: none;
    img {
      height: 1em;
      position: relative;
      top: 0.1em;
      width: auto;
      display: inline-block;
    }
  }
  a.router-link-exact-active {
    font-weight: 400;
  }
  ul ul {
    padding-left: 1.5em;
  }
}
</style>
